import React from "react"

const MultipleValuesSetter = React.memo(({ initial, children }) => {
  const [show, setShow] = React.useState(initial)
  const updateOpen = React.useCallback(() => setShow(true), [])

  if (show) return children
  return (
    <div className="d-flex align-items-center gap-1 py-2">
      <span>Multiple values</span>
      <button className="btn btn-link" onClick={updateOpen}>
        Set new value
      </button>
    </div>
  )
})

MultipleValuesSetter.displayName = "MultipleValuesSetter"

export default MultipleValuesSetter
